import React from 'react'

const Contratos = () => {
   return (
      <>
         <div className="section animated fadeIn">
   
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row mb-title center mb-4">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     CONTRATOS
                  </h4>
               </div>
            </div>

            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     
                     {[
                        {
                           tituloPrincipal: 'Volante de Pago Empleadas Domésticas',
                           tituloSecundario: 'Formulario AFIP F.102/TR',
                           url: `${process.env.REACT_APP_API_URL}/web/download/VolanteDePagoEmpleadasDomesticasFormAfip_F102TR.pdf`
                        },
                        {
                           tituloPrincipal: 'Volante de Pago Intereses de Cuotas',
                           tituloSecundario: 'Formulario AFIP F.801/C',
                           url: `${process.env.REACT_APP_API_URL}/web/download/VolantedePagoInteresesdeCuotasFormAfip_artf000093.pdf`
                        },
                        {
                           tituloPrincipal: 'Volante de Pago de Primera Cuota domésticas',
                           tituloSecundario: 'Formulario AFIP F.575/RT',
                           url: `${process.env.REACT_APP_API_URL}/web/download/VolantedePagodePrimeraCuotadomesticas_FormAfip_F575RT.pdf`
                        },
                        {
                           tituloPrincipal: 'Declaración Jurada sobre la condición de Persona',
                           tituloSecundario: 'Expuesta Políticamente',
                           url: `${process.env.REACT_APP_API_URL}/web/download/DeclaracionJuradasobrelacondiciondePersonaExpuestaPoliticamente.pdf`,
                           conAncla: true
                        }
                     ].map((item, idx, arr) => (
                        <div key={idx}>
                           <div 
                              className="row valign-wrapper" 
                              style={{ 
                                 display: 'flex', 
                                 alignItems: 'center', 
                                 marginBottom: idx === arr.length - 1 && !item.conAncla ? '0' : '15px', 
                                 paddingBottom: idx === arr.length - 1 && !item.conAncla ? '0' : '15px', 
                                 borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #e0e0e0' 
                              }}
                           >
                              <div className="col s8 m9 l10">
                                 <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0 0 4px 0', fontSize: '1rem' }}>
                                    {item.tituloPrincipal}
                                 </h6>
                                 <h6 className="grey-text text-darken-1" style={{ fontWeight: '400', margin: '0', fontSize: '0.9rem' }}>
                                    {item.tituloSecundario}
                                 </h6>
                              </div>
                              <div className="col s4 m3 l2 center-align">
                                 <a 
                                    href={item.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                                    style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                                 >
                                    Descargar
                                    <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>cloud_download</i>
                                 </a>
                              </div>
                           </div>
                           {item.conAncla && <div id="seccionPrevencion" />}
                        </div>
                     ))}

                  </div>
               </div>
            </div>

         </div>
      </>
   );
}

export default Contratos